/**
 * External Dependencies
 */
import 'jquery';
import FontFaceObserver from 'fontfaceobserver/fontfaceobserver';
import 'modaal/dist/js/modaal';
import smoothscroll from 'smoothscroll-polyfill';
import AjaxProjectLoad from './partials/projects-list';
import AjaxPressLoad from './partials/press-list';

smoothscroll.polyfill(); // Smooth scroll for Safari as it's not supported nowadays

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer

Default string of IE 10:
Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)

Default string of IE 11:
Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko

Default string of IE 12 (aka Edge):
Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0

Default string of Edge 13 (thx @DrCord):
Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586

Default string of Edge 14:
Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/14.14300

Test at CodePen:
http://codepen.io/gapcode/pen/vEJNZN
 */

function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }
  /* //De momento no tenemos ningún problema con Edge...
  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
     // Edge (IE 12+) => return version number
     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }
  */
  // other browser
  return false;
}

$(() => {

  var ie_browser = detectIE();
  if (ie_browser !== false) {
    document.documentElement.className += ' fonts-loaded ie ie' + ie_browser;
  } else {
    // fontfaceobserver para evitar FOIT
    // https://fontfaceobserver.com/
    // https://jonsuh.com/blog/font-loading-with-font-events/

    var primaryFont = new FontFaceObserver('Be Vietnam Pro Local');
    var secondaryFont = new FontFaceObserver('Playfair Display Local');

    Promise.all([
      primaryFont.load(),
      secondaryFont.load(),
    ]).then(function () {
      $(document.documentElement).addClass('fonts-loaded');
    });
  }
});


window.addEventListener('load', ()=>{

  /****
   *
   * Video popup Modaal
   *
   ****/
  $('.video-block__button').modaal({
    // content_source: document.querySelector('.wp-block-video'),
    type: 'video',
    before_close: ()=>{
      let playButtons = document.getElementsByClassName('video-block__button');
      Array.prototype.slice.call(playButtons).forEach( playButton => {
        let video = playButton.parentElement.previousElementSibling;

        if(video){
          video.currentTime = 0;
        }

        if(playButton.classList.contains('invisible')){
          playButton.classList.remove('invisible');
        }
      });
    },
  });


  /****
   *
   *  Toggle Open and Close Mobile Menu
   *
   ****/

  function menuToggle(e){
    e.preventDefault();
    let body = document.getElementsByTagName('body')[0];
    body.classList.toggle('menu-visible');
  }

  var closeBtn = document.getElementsByClassName('close-menu');
  var openBtn = document.getElementsByClassName('menu-toggle');

  if(closeBtn.length > 0){
    Array.from(closeBtn).forEach(function(element) {
      element.addEventListener('click', menuToggle, false);
    });
  }

  if(openBtn.length > 0){
    Array.from(openBtn).forEach(function(element) {
      element.addEventListener('click', menuToggle, false);
    });
  }

  /****
   *
   *  Show Boxed Text when pass over the image
   *
   ****/

  function addBoxedTextHoverListener(boxedText){
    let anchorBT = boxedText.children[1];
      boxedText.addEventListener('mouseover', ()=>{
        if(!anchorBT.classList.contains('visible')){
          anchorBT.classList.add('visible');
        }
      });
      boxedText.addEventListener('mouseleave', ()=>{
        if(anchorBT.classList.contains('visible')){
          anchorBT.classList.remove('visible');
        }
      });
  }

  let boxedTexts = document.getElementsByClassName('featured-projects__image');
  if(boxedTexts.length > 0){
    Array.prototype.slice.call(boxedTexts).forEach( boxedText => {
      addBoxedTextHoverListener(boxedText);
    });
  }
  let posts = document.getElementsByClassName('post-project');
  if(posts.length > 0){
    Array.prototype.slice.call(posts).forEach( post => {
      addBoxedTextHoverListener(post);
    });
  }

  if(document.getElementsByClassName('page-template-template-projects').length > 0){
    AjaxProjectLoad.init();
  }

  if(document.getElementsByClassName('page-template-template-press').length > 0){
    AjaxPressLoad.init();
  }

  /****
   *
   *  Fix the info bottom or top depending on window height
   *
   ****/

  if(window.innerWidth >= 1200) {
   var rdrInfo = document.getElementsByClassName('rdr-project-info__sticky');
   if(rdrInfo.length > 0){
     rdrInfo = rdrInfo[0];

     if( (rdrInfo.clientHeight + 100) < window.innerHeight) {
       rdrInfo.classList.add('sticky-top');
     }
   }
  }

  /****
   *
   *  Change the original sendinblue loader
   *
   ****/

  let sibLoader = document.querySelector('.sib_loader img');
  if(sibLoader){
    // eslint-disable-next-line no-undef
    sibLoader.src = ajax_object.spinner_img;
  }

});


